import type { LucideIcon, LucideProps } from 'lucide-react';

/**
 * The one way to draw a UI icon (design system v1): Lucide, 16px, stroke 1.75,
 * `currentColor`. Pass the icon component itself: `<Icon as={Receipt} />`.
 * Sizes: 16 inline (nav, buttons, table actions), 20 in tiles and section
 * headers, 32 at stroke 1.5 in empty states. Decorative by default; pass
 * `label` when the icon carries meaning on its own.
 */
export function Icon({ as: Glyph, size = 16, strokeWidth, label, className, ...rest }:
  Omit<LucideProps, 'ref'> & { as: LucideIcon; label?: string }) {
  return (
    <Glyph
      size={size}
      strokeWidth={strokeWidth ?? (Number(size) >= 28 ? 1.5 : 1.75)}
      className={`shrink-0 ${className ?? ''}`}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
      {...rest}
    />
  );
}
